import script from "./ScrollingPage.vue?vue&type=script&lang=js"
export * from "./ScrollingPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__